import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

export function RaceFilter({ raceNames, selectedRace, onSelect }) {
  if (raceNames.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        pb: 1,
        mb: 2,
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'action.disabled', borderRadius: 2 },
      }}
    >
      <Chip
        label="すべて"
        variant={selectedRace === 'all' ? 'filled' : 'outlined'}
        color={selectedRace === 'all' ? 'primary' : 'default'}
        onClick={() => onSelect('all')}
        sx={{ flexShrink: 0 }}
      />
      {raceNames.map((name) => (
        <Chip
          key={name}
          label={name}
          variant={selectedRace === name ? 'filled' : 'outlined'}
          color={selectedRace === name ? 'primary' : 'default'}
          onClick={() => onSelect(name)}
          sx={{ flexShrink: 0 }}
        />
      ))}
    </Box>
  );
}
